import { render } from "./OcrUploadDoneCard.vue?vue&type=template&id=678cb9e8&scoped=true"
import script from "./OcrUploadDoneCard.vue?vue&type=script&lang=js"
export * from "./OcrUploadDoneCard.vue?vue&type=script&lang=js"

import "./OcrUploadDoneCard.vue?vue&type=style&index=0&id=678cb9e8&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678cb9e8"]])

export default __exports__